const coverSizeControl =(set)=> {

    //csak akkor fut ha letezik az elem
    if ( !document.getElementById(set.coverID) ) { return; }


    const identity = "Cover Control"
    const cover = document.getElementById(set.coverID);
    const aspectRatioRangeDefault = [0.5625,1.7777];




    // check and set aspect ratio settings
    const checkRatioData =(set)=> {



        // checking/setting aspect ratio data
        if (typeof set.aspectRatio.range == 'number'){
            set.aspectRatio.range = [set.aspectRatio.range,0];
        }
        if (!(typeof set.aspectRatio.range == 'object') || set.aspectRatio.range.length == 0){
            set.aspectRatio.range = aspectRatioRangeDefault;
        }
        set.aspectRatio.range.splice(2,set.aspectRatio.range.length - 1);
        if ( !(typeof set.aspectRatio.range[0] == 'number') ){
            set.aspectRatio.range[0] = 0;
        }
        if ( !(typeof set.aspectRatio.range[1] == 'number') ){
            set.aspectRatio.range[1] = 0;
        }
        if (set.aspectRatio.range[0] === 0 && set.aspectRatio.range[1] === 0){
            set.aspectRatio.range = aspectRatioRangeDefault;
        }

        // checking/setting aspect ratio skip range data
        if (typeof set.aspectRatio.skipRange == 'number'){
            set.aspectRatio.skipRange = [set.aspectRatio.skipRange,0];
        }
        if (!(typeof set.aspectRatio.skipRange == 'object') || set.aspectRatio.skipRange.length == 0){
            set.aspectRatio.skipRange = [0,0];
        }
        set.aspectRatio.skipRange.splice(2,set.aspectRatio.skipRange.length - 1);
        if ( !(typeof set.aspectRatio.skipRange[0] == 'number') ){
            set.aspectRatio.skipRange[0] = 0;
        }
        if ( !(typeof set.aspectRatio.skipRange[1] == 'number') ){
            set.aspectRatio.skipRange[1] = 0;
        }

        let ratioData = {
            widest: Math.max( Math.abs(set.aspectRatio.range[0]),Math.abs(set.aspectRatio.range[1]) ),
            tallest: Math.min( Math.abs(set.aspectRatio.range[0]),Math.abs(set.aspectRatio.range[1]) ),
            skipWidest: Math.max( Math.abs(set.aspectRatio.skipRange[0]),Math.abs(set.aspectRatio.skipRange[1]) ),
            skipTallest: Math.min( Math.abs(set.aspectRatio.skipRange[0]),Math.abs(set.aspectRatio.skipRange[1]) ),
        }

        return ratioData;

    }



    // min-max script
    const minMax =(value,min,max)=> {
        if (value >= min) {
            return Math.min(value,max);
        } else {
            return min;
        }
    } 



    // calculates target height in pixel
    const calculateTargetHeight =(targetCoveragePercent)=> {
        // TODO height mod
        return document.documentElement.clientHeight * (targetCoveragePercent/100);
    }



    // calculates target height modifier based on other objects
    const coverHeightModCalc =(input)=> {
        // TODO
        return 50;
    }



    // sets the height of the cover
    const setCoverHeight =(cover, ratioWidest, ratioTallest, ratioSkipWidest, ratioSkipTallest, targetHeight)=> {
        let width = cover.offsetWidth;
        let minHeight = width / ratioWidest;
        let maxHeight = width / ratioTallest;
        let skipMinHeight = width / ratioSkipWidest;
        let skipMaxHeight = width / ratioSkipTallest;
        let skipping = false;

        let coverHeight = targetHeight;
        coverHeight = minMax(coverHeight,minHeight,maxHeight);

        if (coverHeight >= skipMinHeight && coverHeight <= skipMaxHeight) {
            // beleesik a skippelendo savba
            coverHeight = skipMinHeight - 1;
            skipping = true;
        }

        cover.style.height = Math.ceil(coverHeight) + "px";

        let log = {
            width: width,
            minHeight: minHeight,
            maxHeight: maxHeight,
            skipMinHeight: skipMinHeight,
            skipMaxHeight: skipMaxHeight,
            coverHeight: coverHeight,
            skipping: skipping,
        }

        return log;
    }



    let coverHeightMod = coverHeightModCalc();
    let targetHeight = calculateTargetHeight(set.targetCoverage);
    let rData = checkRatioData(set);
    let execution = setCoverHeight(cover, rData.widest, rData.tallest, rData.skipWidest, rData.skipTallest, targetHeight);



    // Logging:

    // devSays(identity,2,"width:",execution.width,'px');
    // devSays(identity,2,"minHeight:",execution.minHeight,'px');
    // devSays(identity,2,"maxHeight:",execution.maxHeight,'px');
    // devSays(identity,2,"skipMinHeight:",execution.skipMinHeight,'px');
    // devSays(identity,2,"skipMaxHeight:",execution.skipMaxHeight,'px');
    //devSays(identity,2,"coverHeight:",execution.coverHeight,'px');
    //devSays(identity,2,"skipping:",execution.skipping);

    // devSays(identity,2,"ratioWidest:",ratioWidest);
    // devSays(identity,2,"ratioTallest:",ratioTallest);
    // devSays(identity,2,"ratioSkipWidest:",ratioSkipWidest);
    // devSays(identity,2,"ratioSkipTallest:",ratioSkipTallest);
    // devSays(identity,2,"targetCoverage:",targetCoverage);
    // devSays(identity,2,"coverHeightMod:",coverHeightMod);



}